import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Refresh: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[18px] h-[18px] stroke-[2px]', className)}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_939_121)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4313 3.42032C11.135 2.67145 9.62852 2.36955 8.1438 2.56113C6.65908 2.75271 5.27853 3.42713 4.21482 4.48051C3.1511 5.53389 2.46323 6.90778 2.25717 8.39056C2.20015 8.80083 2.48652 9.17964 2.8968 9.23666C3.30707 9.29368 3.68587 9.00731 3.74289 8.59704C3.90367 7.44014 4.44036 6.3682 5.27029 5.54633C6.10022 4.72447 7.17735 4.19827 8.33576 4.0488C9.49416 3.89933 10.6696 4.13487 11.681 4.71915C12.3464 5.10359 12.9166 5.62498 13.3567 6.2438H12C11.5858 6.2438 11.25 6.57959 11.25 6.9938C11.25 7.40801 11.5858 7.7438 12 7.7438L14.6083 7.7438C14.6196 7.74406 14.631 7.74406 14.6424 7.7438H15C15.4142 7.7438 15.75 7.40801 15.75 6.9938V3.9938C15.75 3.57959 15.4142 3.2438 15 3.2438C14.5858 3.2438 14.25 3.57959 14.25 3.9938V4.94844C13.7411 4.34066 13.1268 3.82213 12.4313 3.42032ZM15.1033 9.25093C14.693 9.19391 14.3142 9.48028 14.2572 9.89055C14.0964 11.0474 13.5597 12.1194 12.7298 12.9413C11.8998 13.7631 10.8227 14.2893 9.6643 14.4388C8.5059 14.5883 7.33048 14.3527 6.31911 13.7684C5.65365 13.384 5.0835 12.8626 4.64339 12.2438H6.00003C6.41424 12.2438 6.75003 11.908 6.75003 11.4938C6.75003 11.0796 6.41424 10.7438 6.00003 10.7438H3.3918C3.38044 10.7435 3.36905 10.7435 3.35765 10.7438H3.00003C2.58582 10.7438 2.25003 11.0796 2.25003 11.4938V14.4938C2.25003 14.908 2.58582 15.2438 3.00003 15.2438C3.41424 15.2438 3.75003 14.908 3.75003 14.4938V13.5391C4.25895 14.1469 4.87323 14.6655 5.56876 15.0673C6.86502 15.8161 8.37154 16.118 9.85626 15.9265C11.341 15.7349 12.7215 15.0605 13.7852 14.0071C14.849 12.9537 15.5368 11.5798 15.7429 10.097C15.7999 9.68676 15.5135 9.30795 15.1033 9.25093Z"
        fill="currentColor"
        strokeWidth="currentStrokWidth"
      />
    </g>
    <defs>
      <clipPath id="clip0_939_121">
        <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)" />
      </clipPath>
    </defs>
  </svg>
);

export default Refresh;
